import React from 'react';
import Styles from './styles.js'
import Link from 'next/link';
const TitleSectionTwo = ({ title, btnTxt, bg, href, hrefExt }) => {
  return (
    <div>
      {bg == 'black' ? (
        <div className="container-fluid" style={{ backgroundColor: '#161616' }}>
          <div className="lg:container text-center text-md-start pt-4 mt-4 ">
            <div className="row g-0 pt-2 pb-3 justify-content-center  ">
              <div className="col-lg-9 pe-lg-4">
                <div>
                  <h3
                    className="text-uppercase me-lg-2 me-xxl-2 
                    pe-xxl-1 pe-xl-0 me-xl-0  fs-32-36 text-lg-end text-center"
                    style={{ fontFamily: 'Fjalla One', color: 'white', fontWeight: '400' }}>
                    {title}
                  </h3>
                </div>
              </div>
              <div className="col-lg-3 text-center text-lg-start mt-4 mt-lg-1">
                <div>
                  {href ? (
                    <Link href={href}>
                      <button
                        type="button"
                        className="btn  me-lg-auto rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '14px 30px',
                        }}>
                        {btnTxt}
                      </button>
                    </Link>
                  ) : (
                    <a hrefExt={hrefExt} target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className="btn  me-lg-auto rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '14px 30px',
                        }}>
                        {btnTxt}
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="lg:container text-center text-md-start pt-4 mt-4 ">
            <div className="row g-0 pt-2 pb-3 justify-content-center  ">
              <div className="col-lg-9 pe-lg-4  ">
                <div>
                  <h3
                    className="text-uppercase me-lg-2 me-xxl-2 pe-xxl-1
                     pe-xl-0 me-xl-0  fs-32-36 text-lg-end text-center"
                    style={{ fontFamily: 'Fjalla One', color: '#1b1b1b', fontWeight: '400' }}>
                    {title}
                  </h3>
                </div>
              </div>
              <div className="col-lg-3 text-center text-lg-start mt-4 mt-lg-1">
                <div>
                  {href ? (
                    <Link href={href}>
                      <button
                        type="button"
                        className="btn  me-lg-auto rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '14px 28px',
                        }}>
                        {btnTxt}
                      </button>
                    </Link>
                  ) : (
                    <a href={hrefExt} target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className="btn  me-lg-auto rounded-0 "
                        style={{
                          fontFamily: 'Josefin Sans',
                          color: '#010101',
                          backgroundColor: '#FCBD00',
                          fontSize: '18px',
                          padding: '14px 28px',
                        }}>
                        {btnTxt}
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles/>
    </div>
  );
};

export default TitleSectionTwo;
